import MainLayout from "@/components/layout/admin/MainLayout.vue";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import axios from "axios";

export default {
  name: 'generateFerryPayment',
  components: {
    MainLayout,
    Loading,
  },
  data() {
    return {
      isLoading: false,
      ferryPlan: [],
      currency: this.$store.state.setting.currency || '',
    };
  },
  methods: {
    generate() {
      this.isLoading = true;
      axios.get(`student/statement/generate-ferry-payment/${this.$route.params.classStudentId}`)
      .then((response) => {
        this.isLoading = false;
        this.ferryPlan = Array.isArray(response.data) ? response.data : [];
      })
      .catch((error) => {
        this.isLoading = false;
        if (error.response && error.response.status == 401) {
          this.$store.commit('logout');
          window.location.replace('login');
          return;
        }
        const msg = error.response?.data?.message || "Failed to generate ferry payment";
        this.$notification.error(msg, { timer: 3, position: "bottomCenter" });
      });
    },
    removePlanRow(index) {
      if (index >= 0 && index < this.ferryPlan.length) {
        this.ferryPlan.splice(index, 1);
      }
    },
    cancel() {
      this.$router.push({ name: 'studentStatementDetail', params: { tuitionPaymentId: this.$route.params.tuitionPaymentId } });
    },
    submit() {
      if (!this.ferryPlan.length) {
        this.$notification.error("No plan to submit", { timer: 3, position: "bottomCenter" });
        return;
      }
      this.isLoading = true;
      axios.post('student/statement/save-ferry-payment', {
        class_student_id: this.$route.params.classStudentId,
        payments: this.ferryPlan
      })
      .then((response) => {
        this.isLoading = false;
        this.$notification.success(response.data?.message || "Ferry payments saved", { timer: 3, position: "bottomCenter" });
        this.cancel();
      })
      .catch((error) => {
        this.isLoading = false;
        if (error.response && error.response.status == 401) {
          this.$store.commit('logout');
          window.location.replace('login');
          return;
        }
        const msg = error.response?.data?.message || error.response?.data?.error || "Failed to save ferry payments";
        this.$notification.error(msg, { timer: 3, position: "bottomCenter" });
      });
    }
  },
  mounted() {
    this.generate();
  }
};
